module.exports = __webpack_public_path__ + "static/media/plane.74164c95.png";